<script setup>
// eslint-disable-next-line no-undef
defineProps({ id: { type: String, required: true }, disabled: Boolean, multiple: Boolean });
// eslint-disable-next-line no-undef
const emit = defineEmits(['change']);
</script>

<template>
  <div class="absence-document-picker">
    <label :for="id">Añadir justificante{{ multiple ? 's' : '' }}</label>
    <div class="absence-document-picker__field">
      <input :id="id" type="file" :multiple="multiple" :disabled="disabled"
        accept=".pdf,.jpg,.jpeg,.png,.gif,.webp,.doc,.docx"
        :aria-describedby="id + '-help'" @change="emit('change', $event)" />
      <small :id="id + '-help'">PDF, ZIP, RAR, JPG, PNG o Word · Máximo 5 MB por fichero</small>
    </div>
  </div>
</template>

<style scoped lang="scss">
.absence-document-picker {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  width: 100%;
  min-width: 0;
  text-align: left;
  label { flex: 0 0 auto; margin: 0; padding-top: 12px; color: #434343; font-size: 15px; font-weight: 600; white-space: nowrap; }
  &__field { flex: 1; min-width: 0; }
  input {
    display: block;
    width: 100%;
    min-width: 0;
    height: 44px;
    margin: 0;
    padding: 0 12px 0 0;
    border: 1px solid #000;
    border-radius: 20px;
    background: #fff;
    color: #434343;
    font: inherit;
    font-size: 14px;
    line-height: 42px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: pointer;
    &::file-selector-button {
      height: 42px;
      margin: 0 12px 0 0;
      padding: 0 16px;
      border: 0;
      border-right: 1px solid #000;
      border-radius: 20px 0 0 20px;
      background: #f7d20d;
      color: #474ce6;
      font: inherit;
      font-weight: 600;
      cursor: pointer;
    }
    &:hover::file-selector-button { background: rgba(247, 210, 13, .5); }
    &:disabled { opacity: .5; cursor: not-allowed; }
    &:disabled::file-selector-button { cursor: not-allowed; }
  }
  small { display: block; margin-top: 8px; color: #73767a; font-size: 12px; overflow-wrap: anywhere; }
}
@media (max-width: 767px) {
  .absence-document-picker {
    flex-direction: column;
    gap: 8px;
    label { padding-top: 0; }
    &__field { width: 100%; }
    input::file-selector-button { padding: 0 12px; margin-right: 8px; }
  }
}
</style>
